export function composeWorkspaceEndpointUrl(baseUrl?: string | null, path?: string | null): string {
  const base = String(baseUrl || '').replace(/\/+$/g, '');
  const requestPath = String(path || '').trim();
  if (!requestPath) return base;
  return `${base}${requestPath.startsWith('/') ? requestPath : `/${requestPath}`}`;
}

export function normalizeEditableEndpointPath(raw: string): string {
  return String(raw || '').trim();
}
